// extracted by mini-css-extract-plugin
export default {"root":"performance_root__qfYfT","chart":"performance_chart__mKpZv"};